// extracted by mini-css-extract-plugin
export default {"container":"SelectedPage_container__3XmJj","empty":"SelectedPage_empty__kv2O0","clearBtn":"SelectedPage_clearBtn__sq4o4"};